const PackagesBs = () => {

    const allBsPackages = document.querySelectorAll('.packages-bs__items-item');

    if(allBsPackages) {
        allBsPackages.forEach(item => {
            item.addEventListener('click', function() {
                // Pobranie wartości z atrybutu data-value
                var packageDuration = this.getAttribute('data-value');
        
                // Pobranie rodzica o klasie "packages-bs__item"
                var packageTypeElement = this.closest('.packages-bs__item');
                if(!packageTypeElement) {
                    console.error("Nie znaleziono elementu o klasie 'packages-bs__item'.");
                    return;
                }
        
                // Pobranie wartości z atrybutu data-package-bs-type
                var packageType = packageTypeElement.getAttribute('data-package-bs-type');
        
                // Określenie, który wariant dodatkowy wybrać
                var additionalVariant;
                if(packageType === 'standard') {
                    additionalVariant = 'brak';
                } else if(packageType === 'premium') {
                    additionalVariant = 'teleopieka-medyczna';
                } else {
                    console.error(`Nieznany typ pakietu: ${packageType}`);
                    return;
                }
        
                // Znalezienie odpowiedniego dodatkowego wariantu i symulacja kliknięcia
                var additionalVariantElement = document.querySelector(`.wd-swatch[data-value='${additionalVariant}']`);
                if(additionalVariantElement) {
                    additionalVariantElement.click();
                }
        
                // Znalezienie wariantu odpowiadającego klikniętemu elementowi i symulacja kliknięcia
                var matchingVariantElement = document.querySelector(`.wd-swatch[data-value='${packageDuration}']`);
                if(!matchingVariantElement) {
                    console.error(`Nie znaleziono elementu o atrybucie data-value równym '${packageDuration}'.`);
                    return;
                }
                matchingVariantElement.click();
        
                // Dodanie klasy "aktywny" do wybranego elementu
                document.querySelectorAll('.packages-bs__items-item.aktywny').forEach(activeItem => {
                    activeItem.classList.remove('aktywny');
                });
                this.classList.add('aktywny');
            });
        });
    }
}


export default PackagesBs;